/**
 * Human-readable role labels for the customer-plane roles, shared by both
 * SPAs. `super_admin` is intentionally excluded from `ROLE_OPTIONS` — it is a
 * control-plane role and is never assignable to a company user from either
 * portal's role dropdown.
 *
 * (The customer SPA also keeps its own ROLE_LABEL/ROLE_OPTIONS in
 * src/labels/display.ts, which *includes* super_admin for display of existing
 * users; this shared copy is the assignable-options set used by the invite/
 * edit forms.)
 */

const ROLE_LABELS: Record<string, string> = {
  field_rep: 'Field Rep',
  company_admin: 'Company Admin',
  stakeholder: 'Stakeholder',
};

export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

export const ROLE_OPTIONS = (
  ['field_rep', 'company_admin', 'stakeholder'] as const
).map((value) => ({ value, label: ROLE_LABELS[value] }));
